/**
 * Pays et devises proposés pour une boutique (Afrique francophone + France).
 *
 * Source unique : pour ajouter un pays, ajouter une entrée dans PAYS avec le
 * code de sa devise ; pour une nouvelle devise, l'ajouter dans DEVISES.
 * Les listes déroulantes et la devise associée à un pays en sont déduites.
 */

/** Devises disponibles (code ISO 4217). */
export const DEVISES = [
  { code: 'XOF', label: 'Franc CFA BCEAO (XOF)' },
  { code: 'XAF', label: 'Franc CFA BEAC (XAF)' },
  { code: 'GNF', label: 'Franc guinéen (GNF)' },
  { code: 'CDF', label: 'Franc congolais (CDF)' },
  { code: 'KMF', label: 'Franc comorien (KMF)' },
  { code: 'DJF', label: 'Franc djiboutien (DJF)' },
  { code: 'BIF', label: 'Franc burundais (BIF)' },
  { code: 'RWF', label: 'Franc rwandais (RWF)' },
  { code: 'MGA', label: 'Ariary malgache (MGA)' },
  { code: 'MRU', label: 'Ouguiya mauritanien (MRU)' },
  { code: 'MAD', label: 'Dirham marocain (MAD)' },
  { code: 'DZD', label: 'Dinar algérien (DZD)' },
  { code: 'TND', label: 'Dinar tunisien (TND)' },
  { code: 'MUR', label: 'Roupie mauricienne (MUR)' },
  { code: 'SCR', label: 'Roupie seychelloise (SCR)' },
  { code: 'EUR', label: 'Euro (EUR)' },
];

/** Pays disponibles, avec leur devise par défaut. */
export const PAYS = [
  // Zone UEMOA (XOF)
  { code: 'CI', label: 'Côte d’Ivoire', currency: 'XOF' },
  { code: 'SN', label: 'Sénégal', currency: 'XOF' },
  { code: 'ML', label: 'Mali', currency: 'XOF' },
  { code: 'BF', label: 'Burkina Faso', currency: 'XOF' },
  { code: 'BJ', label: 'Bénin', currency: 'XOF' },
  { code: 'TG', label: 'Togo', currency: 'XOF' },
  { code: 'NE', label: 'Niger', currency: 'XOF' },
  // Zone CEMAC (XAF)
  { code: 'CM', label: 'Cameroun', currency: 'XAF' },
  { code: 'GA', label: 'Gabon', currency: 'XAF' },
  { code: 'CG', label: 'Congo-Brazzaville', currency: 'XAF' },
  { code: 'TD', label: 'Tchad', currency: 'XAF' },
  { code: 'CF', label: 'Centrafrique', currency: 'XAF' },
  { code: 'GQ', label: 'Guinée équatoriale', currency: 'XAF' },
  // Autres pays francophones d'Afrique
  { code: 'GN', label: 'Guinée', currency: 'GNF' },
  { code: 'CD', label: 'RD Congo', currency: 'CDF' },
  { code: 'KM', label: 'Comores', currency: 'KMF' },
  { code: 'DJ', label: 'Djibouti', currency: 'DJF' },
  { code: 'BI', label: 'Burundi', currency: 'BIF' },
  { code: 'RW', label: 'Rwanda', currency: 'RWF' },
  { code: 'MG', label: 'Madagascar', currency: 'MGA' },
  { code: 'MR', label: 'Mauritanie', currency: 'MRU' },
  { code: 'MA', label: 'Maroc', currency: 'MAD' },
  { code: 'DZ', label: 'Algérie', currency: 'DZD' },
  { code: 'TN', label: 'Tunisie', currency: 'TND' },
  { code: 'MU', label: 'Maurice', currency: 'MUR' },
  { code: 'SC', label: 'Seychelles', currency: 'SCR' },
  // Europe
  { code: 'FR', label: 'France', currency: 'EUR' },
];

/**
 * Retourne la devise par défaut d'un pays.
 * @param {string} codePays - Code pays ISO (ex: "CI")
 * @param {string} [devisePrecedente] - Devise conservée si le pays est inconnu
 * @returns {string} Code devise
 */
export const deviseDuPays = (codePays, devisePrecedente) =>
  PAYS.find((pays) => pays.code === codePays)?.currency || devisePrecedente;
